import React from 'react';
import './Members.css';
function Members() {
  return (
    <div className='members'>
        <h1>Chairperson</h1>
        <div className='faculty-chairperson'>
        <div className='card'>
            <h6>Dr.C.Gomathy</h6>
            <p>VP (Academics)</p>
        </div>
        <div className='card'>
            <h6>Dr.Shirly Edward.A</h6>
            <p>HOD / ECE</p>
        </div>
        </div>
        <h1>Faculty Coordinator</h1>
        <div className='faculty-coord'>
        <div className='card'>
            <h6>Prof.S.Karthik</h6>
            <p>Selection Grade</p>
        </div>
        </div>
        <h1>Office Bearers</h1>
        <div  className='office-bearers'>
        <div className='card-2'>
            <h6>Thinesh VS</h6>
            <p>4th Yr, Dept. ECE</p>
            <p style={{color:'yellow'}}>Chairman</p>
        </div>
        <div  className='card-2'>
            <h6>BalajiG</h6>
            <p>4th Yr, Dept. ECE</p>
            <p style={{color:'yellow'}}>Vice Chairman</p>
        </div>
        <div  className='card-2'>
            <h6>ABHISHEK K S</h6>
            <p>3rd Yr, Dept. ECE DS</p>
            <p style={{color:'yellow'}}>Treasurer</p>
        </div>
        <div  className='card-2'>
            <h6>S M Nishaant</h6>
            <p>3rd Yr, Dept. ECM</p>
            <p style={{color:'yellow'}}>Secretary</p>
        </div>
        <div  className='card-2'>
            <h6>Abhideep Mustaufi</h6>
            <p>3rd Yr, Dept. ECM</p>
            <p style={{color:'yellow'}}>Vice Secretary</p>
        </div>
        </div>

    </div>
  )
}

export default Members